import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientRisksPage from "@/pages/client/ClientRisksPage";

export const Route = createFileRoute("/client/contracts/$contractId/risks")({
  head: () => pageHead("Client · Contracts · Risks", "AKIVA client · contracts · risks portal.", "/client/contracts/$contractId/risks", true),
  component: ClientRisksPage,
});
